<script>
    export let content
</script>

<h2>{content}</h2>


<style>
    h2{
        color: #efefef;
        padding: 2rem 0 3rem 0;
        font-size: 4.5rem;
        text-align: center;
    }
</style>